import useGetMyAccountSubdomain from '@/api/queries/me/useGetMyAccountSubdomain';

/**
 * Sending a document emails the Customer a client portal link, so an active
 * subdomain is a hard requirement for every send flow.
 */
export const getClientPortalGateReason = (
  entityLabel: 'estimate' | 'proposal'
): string =>
  `Client portal access is required to send ${entityLabel}s. Set up your client portal subdomain in account settings.`;

export const useHasActiveSubdomain = (): boolean => {
  const { data: subdomain } = useGetMyAccountSubdomain();
  return subdomain?.isActive === true;
};
